import React from 'react';
import { Link } from 'react-router-dom';

import { CUISINE_LINKS, SEATTLE_LOCATIONS, PORTLAND_LOCATIONS, AUSTIN_LOCATIONS, SEATTLE_TRUCKS, PORTLAND_TRUCKS, AUSTIN_TRUCKS } from './navLinks';
import styles from './MegaMenu.module.postcss';

function FoodTrucksMenu({ cityName, vehicleType }) {
  const LOCATIONS_BY_CITY = { Portland: PORTLAND_LOCATIONS, Austin: AUSTIN_LOCATIONS };
  const TRUCKS_BY_CITY = { Portland: PORTLAND_TRUCKS, Austin: AUSTIN_TRUCKS };
  const locations = LOCATIONS_BY_CITY[cityName] || SEATTLE_LOCATIONS;
  const trucks = TRUCKS_BY_CITY[cityName] || SEATTLE_TRUCKS;
  const vehicleTypeLower = vehicleType.toLowerCase();

  return (
    <div className={styles.MegaMenu_grid}>
      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>By cuisine</strong>
        <ul>
          { CUISINE_LINKS.map((link) => (
            <li key={link.url}>
              <Link to={link.url}>{link.emoji} {link.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/explore' className={styles.MegaMenu_viewAll}>
          All cuisines
        </Link>
      </div>

      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>Popular spots</strong>
        <ul>
          { locations.map((loc) => (
            <li key={loc.url}>
              <Link to={loc.url}>{loc.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/explore' className={styles.MegaMenu_viewAll}>
          Find food {vehicleTypeLower}s
        </Link>
      </div>

      <div className={styles.MegaMenu_column}>
        <strong className={styles.MegaMenu_heading}>Popular food {vehicleTypeLower}s</strong>
        <ul>
          { trucks.map((truck) => (
            <li key={truck.url}>
              <Link to={truck.url}>{truck.name}</Link>
            </li>
          ))}
        </ul>
        <Link to='/food-trucks' className={styles.MegaMenu_viewAll}>
          All food {vehicleTypeLower}s
        </Link>
      </div>
    </div>
  );
}

export default React.memo(FoodTrucksMenu);
